export const verifyPayment = async (cname: string, sessionId: string) => {
  const accessToken = localStorage.getItem("access_token");
  const response = await fetch(`${process.env.REACT_APP_BE_URL}/verify-payment`, {
    method: 'POST',
    body: JSON.stringify({ cname, session_id: sessionId }),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  if (!response.ok) {
    throw new Error("Failed to verify payment");
  }
  const data = await response.json();
  return data;
};